import type { StyleProp, ViewStyle } from 'react-native'
import { Icon, Button as PaperButton, useTheme } from 'react-native-paper'
import type { IconType } from '@/lib/types'

export interface ButtonProps {
    title: string
    onPress: () => void
    mode?: 'text' | 'outlined' | 'contained'
    icon?: IconType
    loading?: boolean
    loadingTitle?: string
    disabled?: boolean
    color?: string
    compact?: boolean
    style?: StyleProp<ViewStyle>
    contentStyle?: StyleProp<ViewStyle>
    testID?: string
}

export function Button({
    title,
    onPress,
    mode = 'text',
    icon,
    loading,
    loadingTitle,
    disabled,
    color,
    compact,
    style,
    contentStyle,
    testID,
}: ButtonProps) {
    const theme = useTheme()
    const isDisabled = disabled || loading
    const displayTitle = loading && loadingTitle ? loadingTitle : title
    const isContained = mode === 'contained'
    const buttonColor = isContained ? (color ?? theme.colors.primary) : undefined
    const textColor = !isContained ? color : undefined

    const iconProp = icon
        ? (props: { size: number; color: string }) => (
              <Icon source={icon} size={props.size} color={props.color} />
          )
        : undefined

    return (
        <PaperButton
            mode={mode}
            onPress={onPress}
            disabled={isDisabled}
            loading={loading}
            icon={iconProp}
            buttonColor={buttonColor}
            textColor={textColor}
            compact={compact}
            style={style}
            contentStyle={contentStyle}
            testID={testID}
        >
            {displayTitle}
        </PaperButton>
    )
}
